export default __webpack_public_path__ + "locales/ar-SA/Files.json?hash=8216c91fe4375073416ca36d7e3d5316";